import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import {
  Container,
  Paper,
  Typography,
  Box,
  FormControlLabel,
  Switch,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider
} from '@mui/material';
import {
  Brightness4 as DarkIcon,
  Brightness7 as LightIcon,
  Language as LanguageIcon
} from '@mui/icons-material';

const Settings = () => {
  const { t } = useTranslation();
  const { darkMode, toggleDarkMode } = useTheme();
  const { currentLanguage, languages, changeLanguage } = useLanguage();

  const handleLanguageChange = (event) => {
    changeLanguage(event.target.value);
  };

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 4, mt: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          {t('settings.title')}
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" gutterBottom>
            {t('settings.appearance')}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={darkMode}
                onChange={toggleDarkMode}
                color="primary"
              />
            }
            label={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {darkMode ? <DarkIcon sx={{ mr: 1 }} /> : <LightIcon sx={{ mr: 1 }} />}
                {darkMode ? t('settings.darkMode') : t('settings.lightMode')}
              </Box>
            }
          />
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box>
          <Typography variant="h6" gutterBottom>
            {t('settings.language')}
          </Typography>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="language-select-label">
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <LanguageIcon sx={{ mr: 1 }} />
                {t('settings.selectLanguage')}
              </Box>
            </InputLabel>
            <Select
              labelId="language-select-label"
              id="language-select"
              value={currentLanguage}
              label={t('settings.selectLanguage')}
              onChange={handleLanguageChange}
            >
              {languages.map((lang) => (
                <MenuItem key={lang.code} value={lang.code}>
                  {t(`languages.${lang.code}`)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Paper>
    </Container>
  );
};

export default Settings; 